<template>
<!-- 复用组件 半透明黑色遮罩 中间slot替换内容 -->
  <div v-if="isShow" class="page-wrapper page-fixed page-overflow-hidden select">
        <div class="page-background-color-white page-absolute" :class="{'animationToTop': animationToTop}" :style="contentStyle" >
            <slot></slot>
        </div>
        <div class="page-absolute mark" @click="close"></div>
    </div>
</template>

<script>
export default {
    name: "MaskLayout",
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        contentStyle: {
            type: Object,
            default: ()=>{}
        },
        animationToTop: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
        };
    },
    methods: {
        close: function() {
            this.$emit('closeMask', false);
        }
    }
}
</script>

<style scoped>
@keyframes topShow {
    0% {
        bottom: -8rem;
    }
    100% {
        bottom: 0;
    }
}
.select {
    top: 0;
    left: 0;
    z-index: 100;
}
.mark {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 110;
}
.animationToTop {
    animation-name: topShow;
    animation-duration: 0.3s;
    animation-timing-function: linear;
}
</style>